import React from 'react';
import '../style/ComparisonSection.css';
import image1 from '../assets/swift.png';
import image2 from '../assets/i20.png';
import image3 from '../assets/thar.png';
import image4 from '../assets/xuv.png';
import image5 from '../assets/city.png';

const comparisons = [
  {
    id: 1,
    car1: {
      name: 'Maruti Swift',
      price: '₹6.54 - 10.83 Lakh',
      image: image1,
      fuel: 'Petrol',
      mileage: '24.8 kmpl',
      engine: '1197 cc',
      transmission: 'Manual / Automatic',
    },
    car2: {
      name: 'Hyundai i20',
      price: '₹8.96 - 13.26 Lakh',
      image: image2,
      fuel: 'Petrol',
      mileage: '20 kmpl',
      engine: '1197 cc',
      transmission: 'Manual / Automatic',
    },
    compareLabel: 'Swift vs i20',
  },
  {
    id: 2,
    car1: {
      name: 'Mahindra Thar',
      price: '₹10.00 - 18.06 Lakh',
      image: image3,
      fuel: 'Petrol/Diesel',
      mileage: '15 kmpl',
      engine: '2184 cc',
      transmission: 'Manual / Automatic',
    },
    car2: {
      name: 'Mahindra XUV 700',
      price: '₹13.74 - 23.04 Lakh',
      image: image4,
      fuel: 'Petrol/Diesel',
      mileage: '17 kmpl',
      engine: '2198 cc',
      transmission: 'Manual / Automatic',
    },
    compareLabel: 'Thar vs XUV 700',
  },
  {
    id: 3,
    car1: {
      name: 'Honda City',
      price: '₹11.11 - 20.50 Lakh',
      image: image5,
      fuel: 'Petrol / Hybrid',
      mileage: '27 kmpl',
      engine: '1498 cc',
      transmission: 'Manual / CVT',
    },
    car2: {
      name: 'Mahindra XUV 700',
      price: '₹13.74 - 23.04 Lakh',
      image: image4,
      fuel: 'Petrol/Diesel',
      mileage: '17 kmpl',
      engine: '2198 cc',
      transmission: 'Manual / Automatic',
    },
    compareLabel: 'City vs XUV 700',
  },
];

const ComparisonSection = ({ onCompare }) => {
  return (
    <section id="comparison" className="premium-compare-wrapper">
      <div className="compare-intro">
        <span className="compare-eyebrow">The CarsChalao Duel</span>

        <h2 className="compare-title">
          Compare to <span className="blue-accent">buy the right car</span>
        </h2>
      </div>

      <div className="compare-grid-layout">
        {comparisons.map((item) => (
          <div className="premium-compare-card" key={item.id}>
            <div className="duel-visual-stage">
              <div className="car-slot left">
                <img src={item.car1.image} alt={item.car1.name} />
              </div>

              <div className="vs-center-element">
                <div className="vs-line-top"></div>
                <span className="vs-text">VS</span>
                <div className="vs-line-bottom"></div>
              </div>

              <div className="car-slot right">
                <img src={item.car2.image} alt={item.car2.name} />
              </div>
            </div>

            <div className="comparison-meta-info">
              <div className="car-info-stack">
                <h4>{item.car1.name}</h4>
                <p>{item.car1.price}</p>
              </div>

              <div className="car-info-stack align-right">
                <h4>{item.car2.name}</h4>
                <p>{item.car2.price}</p>
              </div>
            </div>

            <button
              className="premium-action-btn"
              onClick={() => onCompare(item.car1, item.car2)}
            >
              Explore {item.compareLabel}
            </button>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ComparisonSection;